import {
  getABTestConfig,
  morphCasaABTestRouteConfig,
} from '@/config/abTestConfig'
import ABTestSectionOutlet from '@app-studio-web/ui/components/ABTestSectionOutlet'

/**
 * MorphCasa onboarding outlet
 * Uses shared ABTestSectionOutlet with app-specific configuration
 *
 * Variants:
 * - baseline: Original shorter flow (control) at /onboarding/*
 * - v1: Extended flow with psychology-based pages at /onboarding/v1/*
 * - v2: Deep Psychological Onboarding (Headway-style) at /onboarding/v2/*
 */
export default function MorphCasaOnboardingOutlet() {
  return (
    <ABTestSectionOutlet
      basePath="/onboarding"
      routeConfig={morphCasaABTestRouteConfig}
      getABTestConfig={getABTestConfig}
      variantPathPrefixes={{ v1: 'v1', v2: 'v2' }}
      validVariants={['baseline', 'v1', 'v2']}
    />
  )
}
